import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04abd5ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-wrapper" }
const _hoisted_2 = { class: "icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "icon-title-wrapper",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push(_ctx.redirectTo)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
      ]),
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.itemsCount >= 0)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "item-count",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push(_ctx.redirectTo)))
        }, _toDisplayString(_ctx.itemsCount), 1))
      : _createCommentVNode("", true)
  ]))
}